import axios from 'axios';
import Vue from 'vue'
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Toast } from "vant";

let http = axios.create({
  baseURL: process.env.ApiRoot,
  // withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function(data) {
    let newData = '';
    for (let k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});


http.interceptors.request.use(
  config => {
    NProgress.start();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  res => {
    NProgress.done();
    //请求成功
    if (res.data.statusCode === 200) {
      //接口成功
      if (res.data.message=='Success') {
        return Promise.resolve(res.data);
      } else {
        return Promise.reject(res.data);
      }
    } else {
      return Promise.reject(res.data);
    }
  },
  error => {
    NProgress.done();
    return Promise.reject(error.response);
  }
)

export default http



// WEBPACK FOOTER //
// ./src/utils/request.js